import BaseComponent from '../abstracts/BaseComponent';

const debug = false;

export default class ListItems extends BaseComponent {
  get SELECTORS() {
    return {
      trigger: this.$options.trigger || '.js-dropdown-trigger'
    }
  }

  constructor(element) {
    super(element);

    debug && console.log('ListItems');
    debug && console.log('this.$options', this.$options);

    this.listing = this.$el.querySelector(this.LISTING_SELECTOR);

    setTimeout(() => this.init(), 0);

    // PITTI20-1235
    if (this.$options.preventDuplicates) {
      this.itemIds = new Set();
      const items = this.$el.querySelectorAll(this.ITEM_SELECTOR);
      items.forEach(item => item.dataset.listItemId && this.itemIds.add(item.dataset.listItemId));
    }

  }

  get LISTING_SELECTOR() {
    // return '.news-listing, .mediagallery-listing, .search-suggestion-list, .press-list';
    return `${this.$options.listingSelector}:last-of-type`;
  }

  get ITEM_SELECTOR() {
    // return '.news-item, .mediagallery-item, .search-suggestion-item, .press-list-item';
    return this.$options.itemSelector;
  }

  async init() {
    this.GRAB(this.CUSTOM_MESSAGES.NEWS_LIST_EVENTS.init, event => this.query = event.query);
    this.GRAB(this.CUSTOM_MESSAGES.NEWS_LIST_EVENTS.filter, this.onFilter);
    this.GRAB(this.CUSTOM_MESSAGES.NEWS_LIST_EVENTS.all, this.onAll);
    
    this.firstResult = this.$options.nextResult;
    const scroll = this.events(document, 'scroll', () => {
      const windowY = window.pageYOffset + window.innerHeight;
      const elementY = this.$el.offsetTop + this.$el.clientHeight;
      return windowY > elementY - 10;
    });

    while (true) {
      debug && console.log('wait for scroll');
      await scroll.next();
      debug && console.log('fulfilled scroll');
  
      if (this.firstResult === -1 || this.blockScroll) {
        continue;
      }

      debug && console.log('wait for items');
      let text = await this.items();
      debug && console.log('fulfilled items');
  
      this.update(text);
    }
  }

  getUrlParameter(query, name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    const results = regex.exec(query);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  };

  onFilter = async event => {
    this.blockScroll = true;
    this.query = event.query;
    debug && console.log('ListItems onFilter');
    debug && console.log('event.query', event.query);
    this.firstResult = 0;
    this.$el.innerHTML = '';

    const filterArray = ['edition', 'serie'];

    filterArray.forEach( (value) => {
      let selectedValue = document.querySelector(`#selected-${value}`);
      if (selectedValue) {
        let elChecked = document.querySelector(`input[name="${value}"]:checked`);
        let label = elChecked.nextElementSibling.textContent;
        selectedValue.innerHTML = label;
        this.EMIT(this.CUSTOM_MESSAGES.DROPDOWN_EVENTS.open, {
          triggerSelector: this.SELECTORS.trigger
        });
      }
    });


    debug && console.log('wait for items');
    let text = await this.items();
    debug && console.log('fulfilled items');
    this.blockScroll = false;
    this.update(text);
  }

  items = () => {
    debug && console.log('ListItems items this.query', this.query);

    return new Promise(resolve => {
      fetch(`${location.pathname}?items=true${this.query ? `&${this.query}` : ''}&first=${this.firstResult}`, {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
          Accept: 'text/html'
        }
      }).then(response => {
        if (response.status === 200) {
          this.listing = this.$el.querySelector(this.LISTING_SELECTOR);
          this.listing && this.listing.classList.add('show-spinner');
          setTimeout(() => {
            this.listing && this.listing.classList.remove('show-spinner');
          }, 1000);
          this.firstResult = parseInt(response.headers.get('Next-Result'));
          debug && console.log('ListItems this.firstResult', this.firstResult);
          return response.text();
        } else {
          throw new Error('Not 200 response');
        }
      }).then(text => {
        resolve(text);
      }).catch(function(err) {
        debug && console.log('ListItems items err', err);
      });
    });
  }

  update = text => {
    debug && console.log('ListItems update text', text);

    if (this.listing) {
      const div = document.createElement('div');

      div.innerHTML = text;
      const items = div.querySelectorAll(this.ITEM_SELECTOR)
      debug && console.log('items.length', items.length);

      items.forEach(item => this.updateItem(item, div));
    } else {
      this.$el.innerHTML = text;
      initVideos(this.$el);

      // TODO
      const calendarDays = this.$el.querySelector('.events-calendar__sidebar ul');
      if (calendarDays) {
        const ul = document.querySelector('.pitti-calendar')
            ? this.$el.previousElementSibling.previousElementSibling.querySelector("ul")
            : this.$el.previousElementSibling.querySelector("ul");
        ul.replaceWith(calendarDays);
      }
    }
    
    // PITTI20-995
    debug && console.log('ListItems dispatchEvent image-changes');
    document.dispatchEvent(new Event('image-changes'));

    this.EMIT(this.CUSTOM_MESSAGES.NEWS_LIST_EVENTS.updateItems, {
      container: this.listing || this.$el
    });
  }

  updateItem = (item, div) => {

    // PITTI20-1235
    if (this.$options.preventDuplicates && item.dataset.listItemId) {
      const duplicate = this.itemIds.has(item.dataset.listItemId);
      debug && console.log('ListItems updateItem itemId', item.dataset.listItemId, 'duplicate', duplicate);
      if (duplicate) {
        return;
      }
      this.itemIds.add(item.dataset.listItemId);
    }

    this.listing.appendChild(item);
    initVideos(item);
  }

  onAll = async msg => {
    while (this.firstResult !== -1) {
      debug && console.log('wait for items');
      let text = await this.items();
      debug && console.log('fulfilled items');
  
      this.update(text);
    }
    msg.callback();
  }
}
